import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-b3',
  templateUrl: './b3.component.html',
  styleUrls: ['./b3.component.scss']
})
export class B3Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
